import React from 'react';
import { ButtonUI, CheckboxUI, DialogUI } from '../../Interface';

const JmEasyMultiManDialog = ({ open, handleClose, data, setSelectedEmployees, handleStartOperation, disableBtn }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Feladaton dolgozó személyek kiválasztása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '900px',
          },
        },
      }}
    >
      <div className="flex mt-5 gap-5 flex-wrap">
        {data?.length > 0 &&
          data.map((item) => (
            <div key={item.userId}>
              <CheckboxUI
                label={item.nickName}
                onChange={() =>
                  setSelectedEmployees((prev) =>
                    prev.includes(item.resourceOneId)
                      ? prev.filter((id) => id !== item.resourceOneId)
                      : [...prev, item.resourceOneId]
                  )
                }
              />
            </div>
          ))}
      </div>
      <div className="text-center mt-5">
        <ButtonUI text="Rögzítés" className="bg-success" disabled={disableBtn} onClick={() => handleStartOperation()} />
      </div>
    </DialogUI>
  );
};

export default JmEasyMultiManDialog;
